type HasId = { id: string };

function isObject(error: unknown): error is Record<any, unknown> {
	return typeof error === 'object' && error !== null;
}

function hasId(error: unknown): error is HasId {
	return isObject(error) && typeof error.id === 'string';
}

export function getErrorId(error: unknown) {
	return hasId(error) ? error.id : 'unknown-id';
}
